import React from 'react';
import PropTypes from 'prop-types';
import { ValidationMessage, FieldBody } from 'web-ui-components/lib/molecules/forms';
import { Select } from 'web-ui-components/lib/atoms/forms';
import withValidation from '../../../../containers/withValidation';
import styles from '../BacsPaymentStyles';

export const TransactionCode = ({
	id,
	onChange,
	transactionCode,
	isValid,
	showValidation,
	invalidMessage,
	options,
}) => {
	const showErrorMessage = !isValid && showValidation;
	return (
		<div>
			<FieldBody>
				<Select
					id={id}
					options={options}
					value={transactionCode}
					onChange={onChange}
					iconType="ChevronDownSolidSmall"
				/>
			</FieldBody>
			{showErrorMessage && (
				<div className={styles.main__validation}>
					<ValidationMessage hasIcon={false} value={invalidMessage} />
				</div>
			)}
		</div>
	);
};

TransactionCode.propTypes = {
	id: PropTypes.string.isRequired,
	transactionCode: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	onChange: PropTypes.func.isRequired,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	invalidMessage: PropTypes.string.isRequired,
};

export default withValidation({ validations: ['required'], key: 'transactionCode' })(TransactionCode);
